import ComplicationSelector from '@ls/grouping-complication-selector';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDefinition as setHoldingAttributeDefinition } from 'state/holdingAttributes/actions';
import HoldingAttributeDefinition from 'state/holdingAttributes/HoldingAttributeDefinition';
import { selectDefinitions } from 'state/holdingAttributes/selectors';
import SelectionState from 'state/selections/SelectionState';
import HoldingAttributesSelectorComplication from './HoldingAttributesSelectorComplication';

const HoldingAttributesSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (idx, definitions) =>
      dispatch(setHoldingAttributeDefinition(idx, definitions)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={HoldingAttributeDefinition.getDefault}
      ComplicationComponent={HoldingAttributesSelectorComplication}
      btnTitle={'Holdings'}
      addMoreText={'Holding Column'}
    />
  );
};

export default HoldingAttributesSelector;
